export const CAMPAIGN_TAB_KEYS = {
  ALL: 'all',
  RUNNING: 'running',
  SCHEDULED: 'scheduled',
  FINISHED: 'finished',
  DRAFTS: 'drafts',
  ORGANIZATION: 'organization',
  MINE: 'mine',
} as const

export type CampaignTabKey =
  (typeof CAMPAIGN_TAB_KEYS)[keyof typeof CAMPAIGN_TAB_KEYS]

export const CAMPAIGN_DEFAULT_TAB: CampaignTabKey = CAMPAIGN_TAB_KEYS.ALL

/**
 * The strip mixes two axes: the first five tabs filter by status, the last two
 * by ownership. They stay in one row because a campaign is only ever in one of
 * them at a time from the reader's point of view.
 */
export const CAMPAIGN_TAB_ORDER: readonly CampaignTabKey[] = [
  CAMPAIGN_TAB_KEYS.ALL,
  CAMPAIGN_TAB_KEYS.RUNNING,
  CAMPAIGN_TAB_KEYS.SCHEDULED,
  CAMPAIGN_TAB_KEYS.FINISHED,
  CAMPAIGN_TAB_KEYS.DRAFTS,
  CAMPAIGN_TAB_KEYS.ORGANIZATION,
  CAMPAIGN_TAB_KEYS.MINE,
]

export function campaignTabLabelKey(tab: CampaignTabKey): string {
  return `campaigns.tabs.${tab}`
}
